import { useState } from 'react'
import { useCustomQuery } from '@salesforce/commerce-sdk-react'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const useAddressGeolocation = (c_address = null) => {
    const [isLoading, setIsLoading] = useState(true)
    const { site } = useMultiSite()

    const { data: location } = useCustomQuery(
        {
            options: {
                method: 'GET',
                parameters: {
                    siteId: site.id,
                    c_address: c_address
                },
                customApiPathParameters: {
                    apiVersion: 'v1',
                    endpointPath: '/geolocation',
                    apiName: 'address'
                }
            },
            rawResponse: false
        },
        {
            enabled: c_address !== null,
            onError: (error) => {
                setIsLoading(false)
                logger.error('Error geo-locating the address:', {
                    namespace: 'geolocation',
                    additionalProperties: { error: error.message, stack: error.stack }
                })
            }
        }
    )


    return {
        isLoading,
        location
    }
}

export { useAddressGeolocation }
